module.exports = __webpack_public_path__ + "img/nissin-1.89da18e8.jpg";